import { CheckCircleOutline, Close } from "@mui/icons-material";
import {
  IconButton,
  Alert as MuiAlert,
  Slide,
  Stack,
  styled,
} from "@mui/material";

import { useToast } from "~/hooks/use-toast";

const Alert = styled(MuiAlert)(({ theme }) => ({
  boxShadow: theme.shadows[2],
  ".MuiSvgIcon-root": {
    fontSize: "22px",
  },
}));

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { Toaster } from '@monthly/ui' */
export function Toaster() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <Stack
      spacing={2}
      sx={{
        position: "fixed",
        top: "68px",
        right: "16px",
        zIndex: 100,
        maxWidth: "320px",
        width: "100%",
      }}
    >
      {toasts.map(({ id, title, description, severity, ...props }) => {
        return (
          <Slide
            key={id}
            in={props.open}
            direction="left"
            timeout={250}
            mountOnEnter
            unmountOnExit
          >
            <Alert
              icon={severity === "success" ? <CheckCircleOutline /> : undefined}
              severity={severity || "success"}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => dismiss(id)}
                >
                  <Close fontSize="small" />
                </IconButton>
              }
            >
              {title}
              {description && <div>{description}</div>}
            </Alert>
          </Slide>
        );
      })}
    </Stack>
  );
}
